import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ebb8f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor-header" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "文件", -1))
const _hoisted_5 = { class: "menu-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "编辑", -1))
const _hoisted_7 = { class: "menu-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "演示", -1))
const _hoisted_9 = { class: "menu-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "帮助", -1))
const _hoisted_11 = { class: "right" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
import useScreening from '@/hooks/useScreening'
import useSlideHandler from '@/hooks/useSlideHandler'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useExport from '@/hooks/useExport'

import HotkeyDoc from './HotkeyDoc.vue'
import FileInput from '@/components/FileInput.vue'
import {
  Tooltip,
  Dropdown,
  Menu,
  Drawer,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const MenuItem = Menu.Item

const mainStore = useMainStore()
const { gridLineSize, showRuler, showSelectPanel } = storeToRefs(mainStore)

const { enterScreening, enterScreeningFromStart } = useScreening()
const { createSlide, deleteSlide, resetSlides } = useSlideHandler()
const { redo, undo } = useHistorySnapshot()
const { importSpecificFile } = useExport()

const setDialogForExport = mainStore.setDialogForExport

const toggleGridLines = () => {
  mainStore.setGridLineSize(gridLineSize.value ? 0 : 50)
}

const toggleRuler = () => {
  mainStore.setRulerState(!showRuler.value)
}

const openSelectPanel = () => {
  if (!showSelectPanel.value) mainStore.setSelectPanelState(true)
  else mainStore.setSelectPanelState(false)
}

const hotkeyDrawerVisible = ref(false)

const goLink = (url: string) => window.open(url)

return (_ctx: any,_cache: any) => {
  const _component_IconFolderClose = _resolveComponent("IconFolderClose")!
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_IconPpt = _resolveComponent("IconPpt")!
  const _component_IconHelpcenter = _resolveComponent("IconHelpcenter")!
  const _component_IconShare = _resolveComponent("IconShare")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Dropdown), { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_unref(Menu), null, {
            default: _withCtx(() => [
              _createVNode(FileInput, {
                accept: ".pptist",
                onChange: _cache[0] || (_cache[0] = files => _unref(importSpecificFile)(files))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(() => [
                      _createTextVNode("导入 pptist 文件")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setDialogForExport)('pptx')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出文件")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_IconFolderClose),
            _createTextVNode(),
            _hoisted_4
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Dropdown), { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_unref(Menu), null, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuItem), {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(undo)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("撤销")
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(redo)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重做")
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(createSlide)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加页面")
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(deleteSlide)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除页面")
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleGridLines()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(gridLineSize) ? '关闭网格线' : '打开网格线'), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleRuler()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(showRuler) ? '关闭标尺' : '打开标尺'), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(resetSlides)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置幻灯片")
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (openSelectPanel()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(showSelectPanel) ? '关闭选择面板' : '打开选择面板'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_IconEdit),
            _createTextVNode(),
            _hoisted_6
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Dropdown), { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_unref(Menu), null, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuItem), {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(enterScreeningFromStart)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("从头开始")
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(enterScreening)()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("从当前页开始")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_IconPpt),
            _createTextVNode(),
            _hoisted_8
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Dropdown), { trigger: ['click'] }, {
        overlay: _withCtx(() => [
          _createVNode(_unref(Menu), null, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuItem), {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (hotkeyDrawerVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("快捷键")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_IconHelpcenter),
            _createTextVNode(),
            _hoisted_10
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        title: "导出"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "menu-item",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(setDialogForExport)('pptx')))
          }, [
            _createVNode(_component_IconShare, {
              size: "18",
              fill: "#666"
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Tooltip), {
        mouseLeaveDelay: 0,
        title: "幻灯片放映"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "menu-item",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(enterScreening)()))
          }, [
            _createVNode(_component_IconPpt, {
              size: "19",
              fill: "#666",
              style: {"margin-top":"1px"}
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Drawer), {
      width: "320",
      placement: "right",
      closable: false,
      visible: hotkeyDrawerVisible.value,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (hotkeyDrawerVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(HotkeyDoc)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})